import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// rental_locations — สถานที่รับ/คืนรถ
// ============================================================================
export const rentalLocations = sqliteTable("car_rental_rental_locations", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  address: text("address"),
  contactPhone: text("contact_phone"),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type RentalLocation = typeof rentalLocations.$inferSelect;
export type NewRentalLocation = typeof rentalLocations.$inferInsert;
